import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_workbox_7986127a from 'nuxt_plugin_workbox_7986127a' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_axios_8ecd4644 from 'nuxt_plugin_axios_8ecd4644' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_sentry_3c12fa56 from 'nuxt_plugin_sentry_3c12fa56' // Source: ../plugins/sentry (mode: 'all')
import nuxt_plugin_i18n_6a80ea94 from 'nuxt_plugin_i18n_6a80ea94' // Source: ../plugins/i18n (mode: 'all')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_analytics_503826e1 from 'nuxt_plugin_analytics_503826e1' // Source: ../utils/analytics (mode: 'all')
import nuxt_plugin_globals_23f2b60c from 'nuxt_plugin_globals_23f2b60c' // Source: ../plugins/globals (mode: 'all')
import nuxt_plugin_modal_341cce12 from 'nuxt_plugin_modal_341cce12' // Source: ../plugins/modal (mode: 'all')
import nuxt_plugin_keyboard_111db95d from 'nuxt_plugin_keyboard_111db95d' // Source: ../plugins/keyboard (mode: 'all')
import nuxt_plugin_icons_34981d38 from 'nuxt_plugin_icons_34981d38' // Source: ../plugins/icons (mode: 'all')
import nuxt_plugin_maintenanceclient_45a3c37b from 'nuxt_plugin_maintenanceclient_45a3c37b' // Source: ../plugins/maintenance.client.js (mode: 'client')
import nuxt_plugin_permission_6b8185c5 from 'nuxt_plugin_permission_6b8185c5' // Source: ../plugins/permission (mode: 'all')
import nuxt_plugin_charts_7265616a from 'nuxt_plugin_charts_7265616a' // Source: ../plugins/charts (mode: 'all')
import nuxt_plugin_theme_335dd7da from 'nuxt_plugin_theme_335dd7da' // Source: ../plugins/theme (mode: 'all')
import nuxt_plugin_portalvue_923e8108 from 'nuxt_plugin_portalvue_923e8108' // Source: ../plugins/portal-vue.js (mode: 'all')
import nuxt_plugin_seo_5e466527 from 'nuxt_plugin_seo_5e466527' // Source: ../plugins/seo (mode: 'all')
import nuxt_plugin_cookiecleanup_31a06b26 from 'nuxt_plugin_cookiecleanup_31a06b26' // Source: ../plugins/cookie-cleanup.js (mode: 'client')
import nuxt_plugin_cookieconsent_3dcc05f0 from 'nuxt_plugin_cookieconsent_3dcc05f0' // Source: ../plugins/cookie-consent.js (mode: 'client')
import nuxt_plugin_utminterceptor_293e45a7 from 'nuxt_plugin_utminterceptor_293e45a7' // Source: ../plugins/utm-interceptor.js (mode: 'client')
import nuxt_plugin_applicationsourceclient_340404e8 from 'nuxt_plugin_applicationsourceclient_340404e8' // Source: ../plugins/application-source.client.js (mode: 'client')
import nuxt_plugin_intercomclient_7af5a0b9 from 'nuxt_plugin_intercomclient_7af5a0b9' // Source: ../plugins/intercom.client.js (mode: 'client')
import nuxt_plugin_posthog_0e671e4d from 'nuxt_plugin_posthog_0e671e4d' // Source: ../plugins/posthog.js (mode: 'client')
import nuxt_plugin_closemodal_1ac05556 from 'nuxt_plugin_closemodal_1ac05556' // Source: ../plugins/close-modal.js (mode: 'all')
import nuxt_plugin_featureflags_54edd67d from 'nuxt_plugin_featureflags_54edd67d' // Source: ../plugins/feature-flags.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":(chunk) => {
      return chunk ? `${chunk} - apropos.jobs` : 'apropos.jobs';
    },"title":"Hiring starts with clarity","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, shrink-to-fit=no, user-scalable=no"},{"hid":"title","name":"title","content":"Apropos.jobs - Hiring starts with clarity"},{"hid":"description","name":"description","content":"Apropos.jobs helps companies define job-roles clearly and align candidates based on working styles and expectations beyond CVs and guesswork before decisions are made."},{"hid":"keywords","name":"keywords","content":"personality assessment, job fit, recruitment, career fit, personality-based hiring, job search, talent acquisition, four-color personality test"},{"name":"author","content":"apropos.jobs"},{"name":"robots","content":"index, follow"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:url","property":"og:url","content":"https:\u002F\u002Fapp.apropos.jobs"},{"hid":"og:title","property":"og:title","content":"Apropos.jobs - Hiring starts with clarity"},{"hid":"og:description","property":"og:description","content":"Apropos.jobs helps companies define job-roles clearly and align candidates based on working styles and expectations beyond CVs and guesswork before decisions are made."},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fapp.apropos.jobs\u002Fwhatsapp-preview-2.png"},{"hid":"og:image:alt","property":"og:image:alt","content":"apropos.jobs - jobs like you. Where fit becomes visible."},{"hid":"og:image:width","property":"og:image:width","content":"1200"},{"hid":"og:image:height","property":"og:image:height","content":"630"},{"hid":"og:site_name","property":"og:site_name","content":"apropos.jobs"},{"hid":"og:locale","property":"og:locale","content":"en_US"},{"hid":"twitter:card","name":"twitter:card","content":"summary_large_image"},{"hid":"twitter:url","name":"twitter:url","content":"https:\u002F\u002Fapp.apropos.jobs"},{"hid":"twitter:title","name":"twitter:title","content":"Apropos.jobs - Hiring starts with clarity"},{"hid":"twitter:description","name":"twitter:description","content":"Apropos.jobs helps companies define job-roles clearly and align candidates based on working styles and expectations beyond CVs and guesswork before decisions are made."},{"hid":"twitter:image","name":"twitter:image","content":"https:\u002F\u002Fapp.apropos.jobs\u002Fwhatsapp-preview-2.png"},{"hid":"twitter:image:alt","name":"twitter:image:alt","content":"apropos.jobs - jobs like you. Where fit becomes visible."},{"name":"apple-mobile-web-app-capable","content":"yes"},{"name":"apple-mobile-web-app-status-bar-style","content":"black-translucent"},{"name":"apple-mobile-web-app-title","content":"apropos.jobs"},{"name":"application-name","content":"apropos.jobs"},{"name":"apple-touch-fullscreen","content":"yes"},{"name":"mobile-web-app-capable","content":"yes"},{"name":"msapplication-TileColor","content":"#292f4c"},{"name":"msapplication-TileImage","content":"\u002Flogo.png"},{"name":"msapplication-config","content":"\u002Fbrowserconfig.xml"},{"name":"theme-color","content":"#292f4c"},{"name":"theme-color","media":"(prefers-color-scheme: light)","content":"#ffffff"},{"name":"theme-color","media":"(prefers-color-scheme: dark)","content":"#292f4c"},{"http-equiv":"X-UA-Compatible","content":"IE=edge"},{"name":"referrer","content":"strict-origin-when-cross-origin"},{"name":"format-detection","content":"telephone=no"}],"link":[{"rel":"dns-prefetch","href":"https:\u002F\u002Fapi.apropos.jobs"},{"rel":"preconnect","href":"https:\u002F\u002Fapi.apropos.jobs"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.googleapis.com"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com","crossorigin":true},{"rel":"manifest","href":"\u002Fsite.webmanifest"},{"rel":"mask-icon","href":"\u002Fsafari-pinned-tab.svg","color":"#292f4c"},{"rel":"shortcut icon","href":"\u002Ffavicon.ico"},{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Ffavicon.ico"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Flogo.png"},{"rel":"apple-touch-icon","href":"\u002Fapple-touch-icon.png"},{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Fapple-touch-icon.png"},{"rel":"canonical","href":"https:\u002F\u002Fapp.apropos.jobs"},{"rel":"alternate","type":"application\u002Frss+xml","title":"apropos.jobs Jobs Feed","href":"\u002Fjobs.xml"},{"rel":"stylesheet","href":"https:\u002F\u002Fuse.typekit.net\u002Fdkt6whe.css"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.client && typeof nuxt_plugin_workbox_7986127a === 'function') {
    await nuxt_plugin_workbox_7986127a(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_8ecd4644 === 'function') {
    await nuxt_plugin_axios_8ecd4644(app.context, inject)
  }

  if (typeof nuxt_plugin_sentry_3c12fa56 === 'function') {
    await nuxt_plugin_sentry_3c12fa56(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_6a80ea94 === 'function') {
    await nuxt_plugin_i18n_6a80ea94(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (typeof nuxt_plugin_analytics_503826e1 === 'function') {
    await nuxt_plugin_analytics_503826e1(app.context, inject)
  }

  if (typeof nuxt_plugin_globals_23f2b60c === 'function') {
    await nuxt_plugin_globals_23f2b60c(app.context, inject)
  }

  if (typeof nuxt_plugin_modal_341cce12 === 'function') {
    await nuxt_plugin_modal_341cce12(app.context, inject)
  }

  if (typeof nuxt_plugin_keyboard_111db95d === 'function') {
    await nuxt_plugin_keyboard_111db95d(app.context, inject)
  }

  if (typeof nuxt_plugin_icons_34981d38 === 'function') {
    await nuxt_plugin_icons_34981d38(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_maintenanceclient_45a3c37b === 'function') {
    await nuxt_plugin_maintenanceclient_45a3c37b(app.context, inject)
  }

  if (typeof nuxt_plugin_permission_6b8185c5 === 'function') {
    await nuxt_plugin_permission_6b8185c5(app.context, inject)
  }

  if (typeof nuxt_plugin_charts_7265616a === 'function') {
    await nuxt_plugin_charts_7265616a(app.context, inject)
  }

  if (typeof nuxt_plugin_theme_335dd7da === 'function') {
    await nuxt_plugin_theme_335dd7da(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_923e8108 === 'function') {
    await nuxt_plugin_portalvue_923e8108(app.context, inject)
  }

  if (typeof nuxt_plugin_seo_5e466527 === 'function') {
    await nuxt_plugin_seo_5e466527(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_cookiecleanup_31a06b26 === 'function') {
    await nuxt_plugin_cookiecleanup_31a06b26(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_cookieconsent_3dcc05f0 === 'function') {
    await nuxt_plugin_cookieconsent_3dcc05f0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_utminterceptor_293e45a7 === 'function') {
    await nuxt_plugin_utminterceptor_293e45a7(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_applicationsourceclient_340404e8 === 'function') {
    await nuxt_plugin_applicationsourceclient_340404e8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_intercomclient_7af5a0b9 === 'function') {
    await nuxt_plugin_intercomclient_7af5a0b9(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_posthog_0e671e4d === 'function') {
    await nuxt_plugin_posthog_0e671e4d(app.context, inject)
  }

  if (typeof nuxt_plugin_closemodal_1ac05556 === 'function') {
    await nuxt_plugin_closemodal_1ac05556(app.context, inject)
  }

  if (typeof nuxt_plugin_featureflags_54edd67d === 'function') {
    await nuxt_plugin_featureflags_54edd67d(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
